export var DEFAULT_NUMBER = 1;
export var MAX_NUMBER_OF_MONTHS = 12;
export var ROOM_CODES = {
  single: 'SB',
  accessible: 'DIS',
  double: 'DB',
  family: 'FAM',
  twin: 'TWIN'
};
export var DEFAULT_SORT_VALUE = '1';
export var VIEW_TYPE = {
  mapView: '1',
  listView: '2'
};
export var URLParams = {
  day: 'ARRdd',
  month: 'ARRmm',
  year: 'ARRyyyy',
  nights: 'NIGHTS',
  adult: 'ADULT',
  child: 'CHILD',
  cot: 'COT',
  roomType: 'INTTYP',
  rooms: 'ROOMS',
  employeeId: 'employeeId',
  alternateSource: 'alt'
};
export var PAYMENT_TYPES = {
  NEW_CARD: 'NEW_CARD',
  NEW_PIBA: 'NEW_PIBA',
  KEEP_CARD: 'KEEP_CARD',
  KEEP_PIBA: 'KEEP_PIBA'
};
export var PAYMENT_RESPONSE_STATUS = {
  FAILURE: 'FAILURE'
};
export var SS_ALTERNATE_PATH = 'alternatePathIB';
export var cardUserType = {
  me: 'me',
  existing: 'existing'
};
export var cardDisplayNameOptions = {
  fullName: 'fullName',
  titleFullName: 'titleFullName',
  initialLastName: 'initialLastName',
  titleInitialLastName: 'titleInitialLastName',
  custom: 'custom'
};